// extracted by mini-css-extract-plugin
export var allrightsreservedWrapper = "style-module--allrightsreservedWrapper--32978";
export var footerBottomWrapper = "style-module--footerBottomWrapper--e778c";
export var footerLink = "style-module--footerLink--89852";
export var footerTopWrapper = "style-module--footerTopWrapper--87484";
export var privacyPolicyWrapper = "style-module--privacyPolicyWrapper--bd259";